module.exports = __webpack_public_path__ + "img/inspect_2.ab1a8b9e.png";